import React from 'react';
import PropTypes from 'prop-types';
import Delay from '../../base/delay';
import { CSSTransition } from 'react-transition-group';

import './tip.scss';

class Tip extends React.Component {
    constructor() {
        super();
        this.state = {
            enabled: false
        };
    }

    onOpen() {
        this.props.onOpen ? this.props.onOpen() : null;
        this.setState({ enabled: true });
    }

    onClose() {
        this.setState({ enabled: false });
    }

    render() {
        const { ignoreDelays, showAfter, hideAfter, tipText } = this.props;
        return (
            <Delay
                showAfter={ignoreDelays ? 99999 : showAfter}
                hideAfter={ignoreDelays ? 99999 : hideAfter}
                onOpen={() => this.onOpen()}
                onClose={() => this.onClose()}
            >
                <CSSTransition
                    in={this.state.enabled}
                    classNames="minimized-frame-tip"
                    timeout={400}
                    appear={true}
                    onExited={() => {
                        this.props.onClose ? this.props.onClose() : null;
                    }}
                    unmountOnExit
                >
                    <div
                        className="minimized-frame-tip"
                        dangerouslySetInnerHTML={{
                            __html: tipText
                        }}
                    />
                </CSSTransition>
            </Delay>
        );
    }
}

Tip.defaultProps = {
    showAfter: 0,
    hideAfter: 0
};

Tip.propTypes = {
    ignoreDelays: PropTypes.bool,
    showAfter: PropTypes.number,
    hideAfter: PropTypes.number,
    tipText: PropTypes.string,
    onOpen: PropTypes.func,
    onClose: PropTypes.func
};

export default Tip;
